module.exports = function getResource(label, vars = []) {
    const resources = {
        freeSamples: 'Échantillons gratuits',
        freeSamplesCTA: `Obtenir ${vars[0]} échantillon(s) gratuits avec chaque commande`,
        samplesAddedText: ` échantillon${vars[0] !== 1 ? 's' : ''} ajouté`,
        done: 'Terminé'
    };

    return resources[label];
};
